import React from 'react';
import I18n from 'i18n-js';
import experiments from '@reverbdotcom/commons/src/experiments';
import QRCode from '../../images/app-install-qr.svg';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

export function AppInstallQRCode(props: IUserContext) {
  if (!isExperimentEnabled(props.user, experiments.APP_INSTALL_CALLOUT_QR_CODE)) return null;

  return (
    <div className="app-install-qr-code">
      <div>
        {I18n.t('discovery.siteSubFooter.getTheApp')}
      </div>
      <img
        className="padding-half bg-white"
        src={QRCode}
        alt={I18n.t('discovery.siteSubFooter.qrCode')}
      />
    </div>
  );
}

export default withUserContext(AppInstallQRCode);
